import { AfterViewChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FileCompositeArray, FileRadiographyArray, FileSTLArray, FileType, FileTypeArray, UpdateFileDto } from 'src/app-client/_appCommon/base/AppInterfaceAndBaseClasses';
import { CRUDFormControllerBase } from 'src/app-client/_appCommon/base/CRUDFormControllerBase';
import { UrlQueryDef } from 'src/app-client/_appCommon/base/UrlQueryDef';
import { CaseDataService } from 'src/app-client/_dataservices/CaseDataService';
import { CaseFileDataService } from 'src/app-client/_dataservices/CaseFileDataService';
import { CaseStageDataService } from 'src/app-client/_dataservices/CaseStageDataService';
import { MediaDataService } from 'src/app-client/_dataservices/MediaDataService';
import { RejectFilesDataService } from 'src/app-client/_dataservices/RejectedFilesDataService';

@Component({
  selector: 'app-file-correction',
  templateUrl: './file-correction.component.html',
  styleUrls: ['./file-correction.component.css'],
  providers: [RejectFilesDataService,MediaDataService,CaseFileDataService,CaseDataService,CaseStageDataService]
})
export class FileCorrectionComponent extends CRUDFormControllerBase<CaseFileDataService> implements AfterViewChecked {

  public rejectedFilesComments: string = "";
  public changesRequiredInSTL:boolean;
  public changesRequiredInImages:boolean;
  public caseId: number;
  public stlForm: FormGroup;
  public compositeForm: FormGroup;
  public radiographyForm: FormGroup;
  public photographyForm: FormGroup;
  public fileSTLArray: any[];
  public fileCompositeArray: any[];
  public fileSingleCompositeArray: any[];
  public fileRadiographyArray: any[];
  public fileImageArray: any[];
  public compositeSingleForm: FormGroup;
  public caseFileId:number;
  public caseFileResponse:any;
  public isComposite:boolean;
  public currentCaseStage:any;
  constructor(
    private router: Router,
    protected route: ActivatedRoute,
    private rejectedFilesDataService: RejectFilesDataService,
    private formBuilder: FormBuilder,
    private cdr:ChangeDetectorRef,
    private mediaDataService: MediaDataService,
    private caseFileDataService: CaseFileDataService,
    private caseDataService:CaseDataService,
    private caseStageDataService:CaseStageDataService
  ) {
    super(route, caseFileDataService);
   }

  ngOnInit(): void {
    this.initializeForms();
    this.initializeArrays();
    this.route.paramMap.subscribe(params => {
      this.caseId = +params.get('id');      
    });

    this.getRejectedFiles()

    let queryDef2 = new UrlQueryDef();
    queryDef2.includes = 'Product,Patient,Customer,Customer.User,CaseHistory,CaseStages,CurrentCaseStage.CaseStage,CurrentCaseStage.CaseStage.Status,CurrentCaseStage.CaseStage.Setup.Prescription';
    this.caseDataService.getById(this.caseId, queryDef2)
    .subscribe((response:any)=>
    {
      let queryDef3 = new UrlQueryDef();
      queryDef3.includes = 'Setup'
      this.caseStageDataService.getById(response.currentCaseStageId,queryDef3)
      .subscribe((caseStageResponse:any)=>
      {
        this.caseFileId=caseStageResponse.setup.caseFileId;
        this.currentCaseStage=caseStageResponse;
        this.getAllCaseFiles();
      })
    })
  }

  ngAfterViewChecked()
  {
    this.cdr.detectChanges();
  }

  getBackCaseList(): void {
    this.router.navigate(['/ecommerce/mis-casos']);
  }

  private getRejectedFiles(): void
  {
    let queryDef = new UrlQueryDef();
    queryDef.filter = "CaseId eq "+this.caseId+" and IsActive eq true";
    this.rejectedFilesDataService.get(queryDef)
    .subscribe((response)=>
    {
      var lastRejectedResponse = response.rows[response.rows.length - 1];
      this.rejectedFilesComments=lastRejectedResponse.rejectedFilesComments;
      this.changesRequiredInSTL=lastRejectedResponse.changesRequiredInSTL;
      this.changesRequiredInImages=lastRejectedResponse.changesRequiredInImages;
    });
  }

  private initializeArrays(): void
  {
    this.fileCompositeArray = JSON.parse(JSON.stringify(FileTypeArray));
    this.fileSingleCompositeArray = JSON.parse(JSON.stringify(FileCompositeArray));
    this.fileRadiographyArray = JSON.parse(JSON.stringify(FileRadiographyArray));
    this.fileSTLArray = JSON.parse(JSON.stringify(FileSTLArray));
  }

  private initializeForms(): void
  {
    this.stlForm = this.formBuilder.group(
      {
        LowerSTL: [null, Validators.required],
        UpperSTL: [null, Validators.required],
        BiteSTL: [null, ''],
      });

    this.radiographyForm = this.formBuilder.group(
      {
        LateralRadiography: [null, ''],
        PanoramicRadiography: [null, ''],
        AditionalRadiography: [null, ''],
      });

    this.compositeForm = this.formBuilder.group(
      {
        LateralExtraoral: [null, ''],
        FrontalExtraoral: [null, ''],
        SmileExtraoral: [null, ''],
        UpperOcclusal: [null, Validators.required],
        LowerOcclusal: [null, Validators.required],
        LeftLateralIntraoral: [null, Validators.required],
        FrontalIntraoral: [null, Validators.required],
        RightLateralIntraoral: [null, Validators.required],
      });

    this.compositeSingleForm = this.formBuilder.group(
      {
        Composite: [null, Validators.required]
      });
  }

  public fileSelected(file: File, item: any, fileArrayype: string): void
  {
    this.mediaDataService.saveImage(file)
      .subscribe((response: any) =>
      {
        if (fileArrayype == "additionalFileAdd")
        {
          this.setFile(item.Id, fileArrayype, response);
          var body = {
            caseId: this.caseId,
            blobId: response.id
          };
        }
        else
        {
          this.setFile(item.type, fileArrayype, response);
        }
        this.insertFileTypeFromMediaId(response.id, item);
      },
      (fail: any) =>
      {
        this.setFile(item.type, fileArrayype, { name: null, url: null });
        this.setWarningAlert(fail.error.message);
      });
  }


  private insertFileTypeFromMediaId(mediaId:number, item: any): void
  {
    let fileDto: UpdateFileDto = {
      id: this.caseFileId,
      fileBlobId: mediaId,
      fileType: item.type
    };

    this.caseFileDataService.updateFile(fileDto)
      .subscribe((response: any) =>
      {
      },
      (fail: any) =>
      {
        this.setWarningAlert(fail.error.message);
      });
  }

  private setFile(fileType: FileType, fileArrayype: string, fileBlobData: any): void
  {
    switch(fileArrayype)
    {
      case 'imageComposite':
        this.fileImageArray.find(x => x.type == fileType).fileInfo = fileBlobData ? { name: fileBlobData.name, url: fileBlobData.path} : null;
        break;
      case 'composite':
        this.fileCompositeArray.find(x => x.type == fileType).fileInfo = fileBlobData ? { name: fileBlobData.name, url: fileBlobData.path} : null;
        break;
      case 'fileSingleComposite':
        this.fileSingleCompositeArray.find(x => x.type == fileType).fileInfo = fileBlobData ? { name: fileBlobData.name, url: fileBlobData.path } : null;
        break;
      case 'radiography':
        this.fileRadiographyArray.find(x => x.type == fileType).fileInfo = fileBlobData ? { name: fileBlobData.name, url: fileBlobData.path} : null;
        break;
      case 'stl':
        this.fileSTLArray.find(x => x.type == fileType).fileInfo = fileBlobData ? { name: fileBlobData.name, url: fileBlobData.path} : null;
        break;
    }
  }

  private getAllCaseFiles(): void
  {
    this.caseFileDataService.getById(this.caseFileId, this.onGetQueryDefForGetCaseFilesById())
      .subscribe((response: any) =>
      {
        this.caseFileResponse = response;
        this.isComposite = response.compositePath == null ? false: true;
      });
  }

  onGetQueryDefForGetCaseFilesById(): UrlQueryDef
  {
    let queryDef = new UrlQueryDef();
    queryDef.includes = "FrontalIntraoral,UpperOcclusal,LowerOcclusal,LeftLateralIntraoral,RightLateralIntraoral,FrontalExtraoral,LateralExtraoral,SmileExtraoral,Composite,PanoramicRadiography,LateralRadiography,AditionalRadiography,BiteSTL,UpperSTL,LowerSTL";
    return queryDef;
  }

  public onSendToScapeStatus():void
  {
    if ((this.stlForm.valid || !this.changesRequiredInSTL)&&(this.compositeForm.valid || !this.changesRequiredInImages || this.isComposite)
      &&(this.compositeSingleForm.valid || !this.changesRequiredInImages || !this.isComposite)) 
    {
      let body =
      {
        id: this.currentCaseStage.id,
        caseId: this.caseId,
        stageNumber: this.currentCaseStage.stageNumber,
        commentsBackoffice: "",
        commentsEcommerce: "",
        updateStageReceivedDateRequired: true,
        isCorrectedRejectFilesRequest: true,
        wasEscapeStatusUsed: true,
      };
      this.caseStageDataService.updateStatus(body)
      .subscribe((res)=>
      {
        this.setSuccessAlert("Estatus actualizado correctamente");
        this.router.navigate(['ecommerce/mis-casos']);
      });
    }
    else{
      this.setInfoAlert("Completa toda la información");
    }
    }

    public deleteFile(item: any, fileArrayype: string)
    {
      let fileDto: UpdateFileDto = {
        id: this.caseFileId,
        fileBlobId: null,
        fileType: item.type
      };
  
      this.caseFileDataService.updateFile(fileDto)
        .subscribe((response: any) =>
        {
          if (fileArrayype == "additionalFileDelete")
          {
            this.setFile(item.Id, fileArrayype, null);
          }
          else
          {
            this.setFile(item.type, fileArrayype, null);
          }
        },
        (fail: any) =>
        {
          this.setWarningAlert(fail.error.message);
        });
    }
    

}
